var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlertsSidenavIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_34_266",
    "data-name": "Component 34 \\u2013 266",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10855",
    "data-name": "Rectangle 10855",
    width: 24,
    height: 24,
    fill: "#fff",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "alert_3_",
    "data-name": "alert (3)",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10758",
    "data-name": "Path 10758",
    d: "M186.266,14.2h-.173a2.1,2.1,0,0,1-2.1-1.977l-.585-10A2.1,2.1,0,0,1,185.508,0h1.343a2.1,2.1,0,0,1,2.1,2.222l-.585,10a2.1,2.1,0,0,1-2.1,1.977Z",
    transform: "translate(-176.407 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10759",
    "data-name": "Path 10759",
    d: "M203.1,406.2a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,203.1,406.2Z",
    transform: "translate(-193.327 -386.656)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10760",
    "data-name": "Path 10760",
    d: "M121.2,256.011a.572.572,0,0,1-.5-.284,5.183,5.183,0,0,1,0-5.216.573.573,0,0,1,.989.577,4.037,4.037,0,0,0,0,4.062.573.573,0,0,1-.494.861Z",
    transform: "translate(-115.419 -240.675)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10761",
    "data-name": "Path 10761",
    d: "M61.51,228.182a.572.572,0,0,1-.5-.284,7.469,7.469,0,0,1,0-7.516.573.573,0,0,1,.989.577,6.323,6.323,0,0,0,0,6.362.573.573,0,0,1-.494.861Z",
    transform: "translate(-57.71 -211.695)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10762",
    "data-name": "Path 10762",
    d: "M1.817,200.309a.572.572,0,0,1-.5-.285,9.78,9.78,0,0,1,0-9.819.573.573,0,0,1,.99.576,8.634,8.634,0,0,0,0,8.667.573.573,0,0,1-.494.861Z",
    transform: "translate(0 -182.671)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10763",
    "data-name": "Path 10763",
    d: "M346.3,256.21a.573.573,0,0,1-.495-.86,4.038,4.038,0,0,0,0-4.048.573.573,0,1,1,.99-.575,5.183,5.183,0,0,1,0,5.2A.572.572,0,0,1,346.3,256.21Z",
    transform: "translate(-332.529 -240.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10764",
    "data-name": "Path 10764",
    d: "M398.167,228.38a.573.573,0,0,1-.495-.86,6.324,6.324,0,0,0,0-6.347.573.573,0,0,1,.99-.575,7.469,7.469,0,0,1,0,7.5A.572.572,0,0,1,398.167,228.38Z",
    transform: "translate(-382.417 -211.902)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10765",
    "data-name": "Path 10765",
    d: "M450.11,200.509a.573.573,0,0,1-.495-.86,8.635,8.635,0,0,0,0-8.651.573.573,0,1,1,.99-.575,9.78,9.78,0,0,1,0,9.8A.572.572,0,0,1,450.11,200.509Z",
    transform: "translate(-432.377 -182.879)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsSidenavIcon);
export default __webpack_public_path__ + "static/media/alertsSidenavIcon.805e0325b1ed393c976004e7e65e04fe.svg";
export { ForwardRef as ReactComponent };